import Facebook from 'assets/svg/facebook/facebook.svg'
import Instagram from 'assets/svg/instagram/instagram.svg'
import Linkedin from 'assets/svg/linkedin/linkedin.svg'
import Icon from 'assets/svg/logo-ralali-icon/logo-ralali-icon.svg'
import Twitter from 'assets/svg/twitter/twitter.svg'
import Youtube from 'assets/svg/youtube/youtube.svg'
import Image from 'common/components/Image'
import SocialMedia from 'common/components/SocialMedia'
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import cdn from 'lib/cdn'
import styled from 'styled-components'

const Footer = styled.div`
  background: ${theme.colors.grayLighter};
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Container = styled.div`
  width: 1180px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StoreWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 382px;
  align-items: center;

  > img:first-child {
    margin-right: 5px;
  }
`

const Pipe = styled.div`
  width: 1px;
  height: 40px;
  margin: 0 20px;
  background-color: ${theme.colors.gray};
`

function FooterCompact(): JSX.Element {
  return (
    <Footer data-testid="landing-footer">
      <Container>
        <Icon />
        <Typography type="rcaption" color="grayDark">
          {`Copyright © ${new Date().getFullYear()} PT. Raksasa Laju Lintang (ralali.com).
          All Rights Reserved`}
        </Typography>
        <StoreWrapper>
          <SocialMedia name="Google Play">
            <Image
              width="106px"
              src={cdn({
                path: '/assets/img/google-play-badge.png',
              })}
            />
          </SocialMedia>
          <SocialMedia name="Apple Store">
            <Image
              width="106px"
              src={cdn({
                path: '/assets/img/app-store-badge.png',
              })}
            />
          </SocialMedia>
        </StoreWrapper>
        <Pipe />
        <Typography type="bparagraph">Ikuti Kami disini:</Typography>
        <SocialMedia name="Facebook">
          <Facebook />
        </SocialMedia>
        <SocialMedia name="Twitter">
          <Twitter />
        </SocialMedia>
        <SocialMedia name="Youtube">
          <Youtube />
        </SocialMedia>
        <SocialMedia name="LinkedIn">
          <Linkedin />
        </SocialMedia>
        <SocialMedia name="Instagram">
          <Instagram />
        </SocialMedia>
      </Container>
    </Footer>
  )
}

export default FooterCompact
